import React from 'react';
import { Icon, IconButton, Tooltip } from '@chakra-ui/react';
import PropTypes, { oneOfType } from 'prop-types';

import { analyticsIds } from '../../../../constants/analyticsIds';
import { CypressIds } from '../../../../constants/cypressIds';

const JobIconButton = ({
  colorScheme = 'darkNeutral',
  icon, label, marginLeft = 0, onClick
}) => (
  <Tooltip label="Export Project">
    <IconButton
      aria-label={label}
      colorScheme={colorScheme}
      data-analytics-id={analyticsIds.projectDetailsPage.downloadRecordsExcelButton}
      data-cy={CypressIds.exportProjectDetailsPageExcelButton}
      icon={<Icon as={icon} boxSize="24px" />}
      ml={marginLeft}
      variant="accent"
      onClick={onClick}
    />
  </Tooltip>
);

JobIconButton.propTypes = {
  colorScheme: PropTypes.string,
  icon: PropTypes.func,
  label: PropTypes.string,
  marginLeft: oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func
};

export default JobIconButton;
